<template>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="store" enctype="multipart/form-data">
            <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"
                      id="description" class="description"/>
            <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                <loading-button
                    :loading="form.processing"
                    class="btn-indigo ml-auto"
                    type="submit"
                >
                    Оновити
                </loading-button>
            </div>
        </form>
    </div>
</template>
<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Layout from "@/Shared/Layout"
import LoadingButton from "@/Shared/LoadingButton"

export default {
    name: "RulesIndex",
    components: {
        LoadingButton,
        ckeditor: CKEditor.component
    },
    props: {
        rules: Object,
    },
    layout: Layout,
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            form: this.$inertia.form({
                description: this.rules?.description ?? '',
            })
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('rules.store'))
        },
    }
}
</script>

<style scoped>

</style>
